<template>
  <div class="base-select">
    <v-select
      :value="value"
      :label="_label"
      v-bind="$attrs"
      outlined
      :rules="validationRules"
      @change="$emit('input', $event)"
    >
      <template
        v-slot:selection="data"
      >
        <slot
          name="selection"
          :item="data.item"
        >
          {{ data.item[$attrs["item-text"] ? $attrs["item-text"] : 'text'] }}
        </slot>
      </template>
      <template
        v-slot:item="data"
      >
        <slot
          name="item"
          :item="data.item"
        >
          {{ data.item[$attrs["item-text"] ? $attrs["item-text"] : 'text'] }}
        </slot>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    value: {
      type: [ String, Object, Number ],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    uppercase: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isHydrated: false
    }
  },
  computed: {
    _label () {
      const label = (this.uppercase)
        ? this.label.toUpperCase()
        : this.label
      return this.required ? label + '*' : label
    },
    validationRules () {
      const rules = [...this.rules]
      if (this.required) {
        rules.push(value => !!value || 'Required')
      }
      return rules
    },
    smAndDown () {
      // Wait until page is loaded to fix bug with breakpoint being incorrect on refresh: https://github.com/vuetifyjs/vuetify/issues/3436
      return this.isHydrated ? this.$vuetify.breakpoint.smAndDown : null
    }
  },
  mounted () {
    this.isHydrated = true
  }
}
</script>
